<div class="portal-layout" [class.portal-layout--full-bleed]="isFullBleedPage()" [class.portal-layout--sidebar-collapsed]="sidebarCollapsed()">
  <app-sidebar-menu (collapsedChange)="sidebarCollapsed.set($event)" />

  <div class="portal-main">
    <app-portal-header />
    <main class="portal-content">
      <router-outlet />
    </main>
  </div>
</div>
